import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button, Card, Container } from "react-bootstrap";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "-"
    : date.toLocaleDateString("en-US");
};

const DriverPayRateAgreementList = () => {
  const navigate = useNavigate();
  const { id: paramId } = useParams();

  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1";
  const loggedInId = localStorage.getItem("userId");
  const userId = isAdmin && paramId ? paramId : loggedInId;

  const [records, setRecords] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/driver-pay-rate-agreement/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        setRecords(res.data || []);
      } catch (err) {
        console.error("Error fetching driver pay rate agreements", err);
      }
    };

    if (userId) {
      fetchData();
    }
  }, [userId]);

  return (
    <Container className="form-wrapper my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Driver Pay Rate Agreement</h3>
        <div>
          <Button
            variant="secondary"
            className="me-2"
            onClick={() =>
              navigate(isAdmin && paramId ? `/userhome/${paramId}` : "/userhome")
            }
          >
            Return
          </Button>
          <Button
            variant="success"
            onClick={() => navigate(`/driver-pay-rate-agreement/${userId}/new`)}
          >
            Add
          </Button>
        </div>
      </div>

      <Card>
        <Card.Body>
          {records.length === 0 ? (
            <div className="text-muted text-center">
              No Driver Pay Rate Agreements found.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "8%" }}>#</th>
                    <th style={{ width: "72%" }}>Date Completed</th>
                    <th style={{ width: "110px" }} className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((record, index) => (
                    <tr key={record.dpra_id}>
                      <td>{index + 1}</td>
                      <td>{formatDate(record.completed_date)}</td>
                      <td className="text-center">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() =>
                            navigate(
                              `/driver-pay-rate-agreement/${userId}/detail/${record.dpra_id}`,
                            )
                          }
                        >
                          Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default DriverPayRateAgreementList;
